export const VALIDATE_CONFIG = {
    errorClass: "text-danger",
    highlight: (element) => {
        if (!jQuery(element).is(":radio"))
            jQuery(element).addClass("is-invalid")
    },
    unhighlight: (element) => {
        jQuery(element).removeClass("is-invalid")
    }
}